<script>
    export let logos;
    export let lang;
    
    let translations = {
        "Pääyhteistyökumppanit": "Main partners",
        "Yhteistyökumppanit": "Partners",
        "Yhteistyössä": "In cooperation with",
        "Mediakumppanit": "Media partners",
        "Tukijat": "We thank for support"
    }
</script>
{#each logos as logogroup}
    {#if logogroup.name != "Mediakumppanit" && logogroup.name != "Tukijat"}
        {#if lang == "FI"}
            <h2>{@html logogroup.name}</h2>
        {:else}
            <h2>{translations[logogroup.plainname]}</h2>
        {/if}
        <div class="logolist">
            {#each logogroup.logos as logo}
                <a href={logo.link.url} target={logo.link.target}>
                    <img src={logo.mediaUrl} alt={logo.link.title} style={logo.sizeStyle}/>
                </a>
            {/each}
        </div>
    {/if}
{/each}
<div class="logolist-columns">
{#each logos as logogroup}
    {#if logogroup.name == "Mediakumppanit" || logogroup.name == "Tukijat"}
        <div>
            {#if lang == "fi"}
                <h2>{@html logogroup.name}</h2>
            {:else}
                <h2>{translations[logogroup.plainname]}</h2>
            {/if}
            <div class="logolist">
                {#each logogroup.logos as logo}
                    <a href={logo.link.url} target={logo.link.target}>
                        <img src={logo.mediaUrl} alt={logo.link.title} style={logo.sizeStyle}/>
                    </a>
                {/each}
            </div>
        </div>
    {/if}
{/each}
</div>
<style>
h2{
    text-align: center;
    margin-bottom: 30px;
}
.logolist{
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        align-items: center;
        justify-content: center;
        gap: 30px;
        margin-top: 15px;
        margin-bottom: 75px;
    }

    .logolist-columns{
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-template-rows: auto;
        gap: 60px;
    }

    @media (max-width: 767px) {
        .logolist-columns{
            grid-template-columns: 1fr;
            gap: 30px;
        }
    }
</style>